import React, { useEffect, useMemo, useState } from 'react';
import { Box, styled, Grid, Typography } from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import PieChartInProcess from './PieChartInProcess';
import InProcessAreaTable from './InProcessAreaTable';
import { numberWithCommas } from '../../../util';
import { api } from '../../../api';

interface SummaryInplantPersonType {
  person_type_id: number;
  person_type: string;
  total: number;
}
interface SummaryInplant {
  total: number;
  total_person_type: SummaryInplantPersonType[];
}

const InProductionProcess: React.FC = () => {
  const [summary, setSummary] = useState<SummaryInplant>({
    total: 0,
    total_person_type: []
  });

  const summaryData = useMemo(
    () => [
      { title: 'Total', amount: summary.total },
      ...summary.total_person_type.map((data) => ({ title: data.person_type, amount: data.total }))
    ],
    [summary]
  );

  useEffect(() => {
    api.get<SummaryInplant>(`/summary-inplant`).then((res) => {
      const { data } = res;
      setSummary(data);
    });
  }, []);

  return (
    <Container>
      <PageHeader text="บุคคลในพื้นที่กระบวนการผลิต" />
      <Grid container sx={{ marginY: 3 }}>
        {summaryData.map((item, index) => (
          <SummaryAmountGrid item xs={3} key={`summary-box-${index}`}>
            <SummaryAmountBox>
              <Typography variant="caption">{item.title}</Typography>
              <Typography variant="h6">{numberWithCommas(item.amount)}</Typography>
            </SummaryAmountBox>
          </SummaryAmountGrid>
        ))}
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={9}>
          <InProcessAreaTable />
        </Grid>
        <Grid item xs={3}>
          <PieChartInProcess
            data={summary.total_person_type.map((data) => ({
              name: data.person_type,
              value: data.total
            }))}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default InProductionProcess;

const Container = styled('div')`
  padding: 16px;
`;

const SummaryAmountBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: 16
}));

const SummaryAmountGrid = styled(Grid)({
  borderRight: '1px solid lightgray',
  '&:last-child': {
    borderRight: 'none'
  }
});
